import React, { useState } from "react";
import {
  showNotification
} from "../../utils"
import "react-notifications-component/dist/theme.css";
import "./register_form.css";
import Api from "../../api";
import Select from "../Select";
import {
  DOCUMENT_TYPES,
  MONTHLY_INTENSITY,
  LANGUAGES,
  ROL_OPTIONS
} from "../../consts";

const Register_form = () => {
  const [formData, setFormData] = useState({
    contract_expiration: "",
    monthly_intensity: "",
    customer_id: "",
    customer_id_type: "",
    email: "",
    first_name: "",
    maternal_last_name: "",
    middle_name: "",
    language: "",
    password: "",
    paternal_last_name: "",
    roles: [],
  });
  const [passwordShown, setPasswordShown] = useState(false);

  const registerUserReq = async () => {
    try {
      const data = await Api.User.Create({ ...formData, roles: formData.roles.map(rol => rol.value) })
      showNotification("¡Exito!", "Usuario creado", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      showNotification("Error", error.message, "warning");
    }
  }

  const handleClearFields = () => {
    setFormData({
      customer_id: "",
      customer_id_type: "",
      first_name: "",
      middle_name: "",
      paternal_last_name: "",
      maternal_last_name: "",
      contract_expiration: "",
      monthly_intensity: "",
      language: "",
      email: "",
      password: "",
      roles: [],
    });
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <>
      <div className="register-container-user_handle">
        <div className="form-container-user_handle">
          <h1>Registrar Usuario</h1>
          <form className="form-register">

            <div className="pair-container">
              <div className="customer-id_container">
                Ingrese numero de identificacion
                <input
                  className="customer_id"
                  type="text"
                  id="customer_id-ftch"
                  placeholder="Identificacion"
                  value={formData.customer_id}
                  onChange={(e) =>
                    setFormData({ ...formData, customer_id: e.target.value })
                  }
                />
              </div>

              <div className="customer_id_type">
                Seleccione tipo de documento de identidad
                <Select
                  name="customer_id_type"
                  options={DOCUMENT_TYPES}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={DOCUMENT_TYPES.find(dc => dc.value === formData.customer_id_type)}
                  onChange={(selected) => {
                    setFormData({ ...formData, customer_id_type: selected.value })
                  }}
                />
              </div>
            </div>

            <div className="pair-container">

              <div className="customer-id_container">
                Primer nombre
                <input
                  type="text"
                  id="first_name"
                  placeholder="Primer nombre"
                  value={formData.first_name}
                  onChange={(e) =>
                    setFormData({ ...formData, first_name: e.target.value })
                  }
                />
              </div>

              <div className="customer_id_type">
                Segundo nombre
                <input
                  type="text"
                  id="middle_name"
                  placeholder="Segundo nombre"
                  value={formData.middle_name}
                  onChange={(e) =>
                    setFormData({ ...formData, middle_name: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="pair-container">

              <div className="customer-id_container">
                Primer apellido
                <input
                  type="text"
                  id="paternal_last_name"
                  placeholder="Primer apellido"
                  value={formData.paternal_last_name}
                  onChange={(e) =>
                    setFormData({ ...formData, paternal_last_name: e.target.value })
                  }
                />
              </div>

              <div className="customer_id_type">
                Segundo apellido
                <input
                  type="text"
                  id="maternalLastName"
                  placeholder="Segundo apellido"
                  value={formData.maternal_last_name}
                  onChange={(e) =>
                    setFormData({ ...formData, maternal_last_name: e.target.value })
                  }
                />
              </div>
            </div>


            <div className="pair-container">

              <div className="customer-id_container">
                Fecha expiracion del contrato (Estudiante):
                <input
                  className="contract_expiration"
                  type="date"
                  id="contract_expiration"
                  name="contract_expiration"
                  value={formData.contract_expiration}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      contract_expiration: e.target.value,
                    })
                  }
                />
              </div>

              <div className="customer_id_type">
                Intensidad mensual en horas (Estudiante):
                <Select
                  name="monthly_intensity"
                  options={MONTHLY_INTENSITY}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={MONTHLY_INTENSITY.find(dc => dc.value === formData.monthly_intensity)}
                  onChange={(selected) => {
                    setFormData({ ...formData, monthly_intensity: selected.value })
                  }}
                />
              </div>
            </div>


            <div className="pair-container">

              <div className="customer-id_container">
                Lenguaje (Profesor):
                <Select
                  name="language"
                  options={LANGUAGES}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={LANGUAGES.find(dc => dc.value === formData.language)}
                  onChange={(selected) => {
                    setFormData({ ...formData, language: selected.value })
                  }}
                />
              </div>

              <div className="customer_id_type">
                Correo
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="pair-container">

              <div className="customer-id_container">
                Contraseña
                <input
                  className="register_form-password_input"
                  type={passwordShown ? "text" : "password"}
                  id="password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                />
                <i onClick={togglePassword} className="fa fa-eye" id="eye"></i>
              </div>

              <div className="customer_id_type">
                Seleccione el rol o roles
                <Select
                  isMulti
                  name="roles"
                  options={ROL_OPTIONS}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={formData.roles}
                  onChange={(selectedRoles) => {
                    setFormData({ ...formData, roles: selectedRoles })
                  }
                  }
                />
              </div>
            </div>

            <div className="submit-buttons-container">
              <input
                className="button_register"
                type="button"
                value="Enviar"
                onClick={registerUserReq}
              />

              <button
                className="button-clear_fields"
                type="button"
                onClick={handleClearFields}
              >
                Limpiar Campos
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

export default Register_form;
